import React from 'react';
import CTAButton from './CTAButton';
export function PricingSection() {
  return <section id="compra" className="py-6 px-4 bg-gradient-to-b from-green-50 to-white" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-6" data-id="element-145">
          💰 VALOR REAL
        </h2>

        <div className="bg-white p-5 rounded-lg shadow-2xl mb-4" data-id="element-146">
          <div className="space-y-3 mb-4" data-id="element-147">
            <div className="flex justify-between items-center border-b pb-3" data-id="element-148">
              <span className="text-xl" data-id="element-149">6 tomos</span>
              <span className="text-xl font-bold" data-id="element-150">$47000</span>
            </div>
            <div className="flex justify-between items-center border-b pb-3" data-id="element-151">
              <span className="text-xl" data-id="element-152">3 bonos</span>
              <span className="text-xl font-bold" data-id="element-153">$20000</span>
            </div>
            <div className="flex justify-between items-center border-b-2 border-black pb-3" data-id="element-154">
              <span className="text-2xl font-bold" data-id="element-155">💥 TOTAL:</span>
              <span className="text-2xl font-bold line-through text-red-600" data-id="element-156">
                $67000
              </span>
            </div>
          </div>

          <div className="bg-gradient-to-r from-green-500 to-green-600 p-5 rounded-lg text-center mb-4" data-id="element-157">
            <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-158">
              🔥 HOY PUEDES ACCEDER POR:
            </p>
            <p className="text-5xl md:text-7xl font-black text-yellow-300 mb-1" data-id="element-159">
              $19990
            </p>
            <p className="text-lg text-white font-bold" data-id="element-160">ARS</p>
          </div>

          <CTAButton text="¡SÍ! QUIERO ACCEDER AHORA POR $19,990" isCheckout data-id="element-161" />
        </div>

        <div className="bg-red-50 p-5 rounded-lg shadow-lg border-4 border-red-500" data-id="element-162">
          <h3 className="text-2xl md:text-4xl font-black text-red-600 text-center mb-2" data-id="element-163">
            ⏳ IMPORTANTE
          </h3>
          <p className="text-xl text-center mb-2" data-id="element-164">Este precio es promocional</p>
          <p className="text-xl text-center font-bold" data-id="element-165">
            y puede cambiar en cualquier momento.
          </p>
        </div>
      </div>
    </section>;
}
export default PricingSection;